import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  deleteSla,
  downloadSample,
  downloadSampleSms,
  downloadSamplebulk,
  editSla,
  getOrder,
  getSla,
  getSmsType,
  getZidMerchants,
  getZidMerchantsByStoreId,
  getZidProducts,
  getZidProductsByStoreId,
  postBulkOrder,
  postMsg,
  postOrders,
  postSla,
  postZidMerchants,
  printBill,
  printBulkBill,
  putZidMerchants,
  putZidProduct,
  syncZidProduct,
  syncZidProductByStoreId,
  uploadBulkprint,
  uploadReciver,
} from "../services/aone_services";
import {
  getDivisors,
  getDivisorById,
  postDivisor,
  editDivisor,
  deleteDivisor,
  bulkDeleteDivisors,
  divisorTemplate,
  importDivisors,
  resolveDivisor,
  exportDivisors,
  editDivisorState,
} from "../services/Masters/Divisor_services";

const initialValues = {
  slaData: [],
  orderData: [],
  zidProductsData: [],
  zidMerchantsData: [],
  originData: [],
  destinationData: [],
  selectedZoneCodes: [],
  sortingConfigData: [],
  billingArrayData: [],
  customerArrayData: [],
  bankArrayData: [],
  tierCountry: "",
  tierName: "",
  iccTabs: 1,
  globalHubCode: "",
  globalproductCode: "",
  globalcustomerAccount: "",
  globalOrderDetail: [],
  globalCusName: "",
  globalDpsName: "",
  globalCusType: "",
  globalZatcaType: "",
  globalBillingCountry: "",
  globalAllowInvoice: "",
  globalEmployeeCode: "",
  globalAccessHubs: [],
  globalFirstname: "",
  globalJobtitle: "",
  globalEmail: "",
  productsPage: -1,
  customersPage: -1,
  globalEmployeeStatus: false,
  globalCustomerStatus: false,
  globalUserStatus: false,
  globalHub: false,
  globalPrefferedLanguage: false,
  isEditPickup: false,
  saveHandler: false,
  isdropModalOpen: false,
  isReactselectOpen: false,
  isReactselectCity: false,
  isReactCalcType: false,
  isReactoriginselectCity: false,
  ispostAdded: false,
  isReactselectRegion: false,
  isReactselectHub: false,
  isReactselectDesHub: false,
  isReactselectCurrHub: false,
  isReactdesCity: false,
  isReactbillingCountryRegion: false,
  isReactdesCountry: false,
  isReactdesPayment: false,
  isReactdesBulk: false,
  isReactPickup: false,
  isReactReasons: false,
  isReactDelivery: false,
  isReactDate: false,
  isReactdesRegion: false,
  isReactRates: false,
  isReactCharges: false,
  isReactCurrency: false,
  isReactRatestate: false,
  isReactRatesType: false,
  isReportsClicked: false,
  formState: {},
  bankState: {},
  isTabChanging: false,
};

let aoneStore = (set) => ({
  ...initialValues,
  getSla: async (data) => {
    const response = await getSla(data);
    set({ slaData: response });
    return response;
  },
  postSla: async (data) => {
    const response = await postSla(data);
    return response;
  },
  editSla: async (data) => {
    const response = await editSla(data);
    return response;
  },
  deleteSla: async (data) => {
    const response = await deleteSla(data);
    return response;
  },
  getOrder: async (params) => {
    const response = await getOrder(params);
    set({ orderData: response });
    return response;
  },
  postOrders: async (data) => {
    const response = await postOrders(data);
    return response;
  },
  postBulkOrder: async (data) => {
    const response = await postBulkOrder(data);
    return response;
  },
  downloadSample: async () => {
    const response = await downloadSample();
    return response;
  },
  printBill: async (data) => {
    const response = await printBill(data);
    return response;
  },
  postMsg: async (data) => {
    const response = await postMsg(data);
    return response;
  },
  printBulkBill: async (data) => {
    const response = await printBulkBill(data);
    return response;
  },
  downloadSampleSms: async () => {
    const response = await downloadSampleSms();
    return response;
  },
  uploadReciver: async (data) => {
    const response = await uploadReciver(data);
    return response;
  },
  getSmsType: async () => {
    const response = await getSmsType();
    return response;
  },
  downloadSamplebulk: async () => {
    const response = await downloadSamplebulk();
    return response;
  },
  uploadBulkprint: async (data) => {
    const response = await uploadBulkprint(data);
    return response;
  },
  getZidProducts: async (params) => {
    const response = await getZidProducts(params);
    set({ zidProductsData: response });
    return response;
  },
  syncZidProduct: async () => {
    const response = await syncZidProduct();
    return response;
  },
  putZidProduct: async (params, data) => {
    const response = await putZidProduct(params, data);
    return response;
  },
  getZidProductsByStoreId: async (params) => {
    const response = await getZidProductsByStoreId(params);
    set({ zidProductsData: response });
    return response;
  },
  syncZidProductByStoreId: async (params) => {
    const response = await syncZidProductByStoreId(params);
    return response;
  },
  getZidMerchants: async () => {
    const response = await getZidMerchants();
    set({ zidMerchantsData: response });
    return response;
  },
  getZidMerchantsByStoreId: async (params) => {
    const response = await getZidMerchantsByStoreId(params);
    set({ zidMerchantsData: response });
    return response;
  },
  postZidMerchants: async (data) => {
    const response = await postZidMerchants(data);
    return response;
  },
  putZidMerchants: async (params, data) => {
    const response = await putZidMerchants(params, data);
    return response;
  },
  setcustomerArrayData: (newState) => set({ customerArrayData: newState }),
  setbillingArrayData: (newState) => set({ billingArrayData: newState }),
  setbankArrayData: (newState) => set({ bankArrayData: newState }),
  setSaveHandler: (data) => set({ saveHandler: data }),
  setisEditPickup: (data) => set({ isEditPickup: data }),
  setcustomerAccount: (data) => set({ globalcustomerAccount: data }),
  setOrderDetail: (data) => set({ globalOrderDetail: data }),
  setGlobalAccessHubs: (data) => set({ globalAccessHubs: data }),
  setglobalEmployeeCode: (data) => set({ globalEmployeeCode: data }),
  setglobalproductCode: (data) => set({ globalproductCode: data }),
  setglobalHubCode: (data) => set({ globalHubCode: data }),
  settierName: (data) => set({ tierName: data }),
  setIccTab: (data) => set({ iccTabs: data }),
  settierCountry: (data) => set({ tierCountry: data }),
  setglobalDepartment: (data) => set({ globalDepartment: data }),
  setglobalFirstname: (data) => set({ globalFirstname: data }),
  setglobalCusName: (data) => set({ globalCusName: data }),
  setglobalDpsName: (data) => set({ globalDpsName: data }),
  setglobalCusType: (data) => set({ globalCusType: data }),
  setglobalZatcaType: (data) => set({ globalZatcaType: data }),
  setglobalBillingCountry: (data) => set({ globalBillingCountry: data }),
  setglobalAllowInvoice: (data) => set({ globalAllowInvoice: data }),
  setglobalLastname: (data) => set({ globalLastname: data }),
  setglobalJobtitle: (data) => set({ globalJobtitle: data }),
  setglobalEmployeeStatus: (data) => set({ globalEmployeeStatus: data }),
  setglobalCustomerStatus: (data) => set({ globalCustomerStatus: data }),
  setglobalUserStatus: (data) => set({ globalUserStatus: data }),
  setglobalHub: (data) => set({ globalHub: data }),
  setglobalPrefferedLanguage: (data) => set({ globalPrefferedLanguage: data }),
  setglobalEmail: (data) => set({ globalEmail: data }),
  setProductsPage: (data) => set({ productsPage: data }),
  setCustomersPage: (data) => set({ customersPage: data }),
  isdropModalOpen: (data) => set({ isdropModalOpen: data }),
  setispostAdded: (data) => set({ ispostAdded: data }),
  setReactSelect: (data) => set({ isReactselectOpen: data }),
  setReactSelectcity: (data) => set({ isReactselectCity: data }),
  setReactCalcType: (data) => set({ isReactCalcType: data }),
  setReactSelectorigincity: (data) => set({ isReactoriginselectCity: data }),
  setReactSelectregion: (data) => set({ isReactselectRegion: data }),
  setReactSelectHub: (data) => set({ isReactselectHub: data }),
  setReactSelectDesHub: (data) => set({ isReactselectDesHub: data }),
  setReactSelectCurrHub: (data) => set({ isReactselectCurrHub: data }),
  setReactDescity: (data) => set({ isReactdesCity: data }),
  setReactBillingCountryregion: (data) => set({ isReactbillingCountryRegion: data }),
  setReactDesCountry: (data) => set({ isReactdesCountry: data }),
  setReactPayment: (data) => set({ isReactdesPayment: data }),
  setReactDesBulk: (data) => set({ isReactdesBulk: data }),
  setReactPickup: (data) => set({ isReactPickup: data }),
  setReactReasons: (data) => set({ isReactReasons: data }),
  setReactDelivery: (data) => set({ isReactDelivery: data }),
  setReactDate: (data) => set({ isReactDate: data }),
  setReactDesregion: (data) => set({ isReactdesRegion: data }),
  setReactRates: (data) => set({ isReactRates: data }),
  setOriginData: (data) => set({ originData: data }),
  setDestinationData: (data) => set({ destinationData: data }),
  setReactCharges: (data) => set({ isReactCharges: data }),
  setReactCurrency: (data) => set({ isReactCurrency: data }),
  setisReactRatestate: (data) => set({ isReactRatestate: data }),
  setisReactRatesType: (data) => set({ isReactRatesType: data }),
  setisReportsClicked: (data) => set({ isReportsClicked: data }),
  setSelectedZoneCode: (newSelectedZoneCodes) =>
    set({ selectedZoneCodes: newSelectedZoneCodes }),
  setFormState: (newState) => set({ formState: newState }),
  setBankState: (newState) => set({ bankState: newState }),
  toggleIsTabChanging: () =>
    set((state) => ({ isTabChanging: !state.isTabChanging })),
  getDivisors: async (params) => {
    const response = await getDivisors(params);
    return response;
  },
  getDivisorById: async (id) => {
    const response = await getDivisorById(id);
    return response;
  },
  postDivisor: async (data) => {
    const response = await postDivisor(data);
    return response;
  },
  editDivisor: async (id, data) => {
    const response = await editDivisor(id, data);
    return response;
  },
  deleteDivisor: async (id) => {
    const response = await deleteDivisor(id);
    return response;
  },
  bulkDeleteDivisors: async (data) => {
    const response = await bulkDeleteDivisors(data);
    return response;
  },
  divisorTemplate: async () => {
    const response = await divisorTemplate();
    return response;
  },
  importDivisors: async (data) => {
    const response = await importDivisors(data);
    return response;
  },
  resolveDivisor: async (params) => {
    const response = await resolveDivisor(params);
    return response;
  },
  exportDivisors: async (params) => {
    const response = await exportDivisors(params);
    return response;
  },
  editDivisorState: async (state, data) => {
    const response = await editDivisorState(state, data);
    return response;
  },
});

aoneStore = devtools(aoneStore);

export const useAoneStore = create(aoneStore);
